<script>
export default {
    name: 'IconArrowheadTop',
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="base-icon icon-arrowhead-top" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M0 44.6 31.867 14l.132.129.133-.129L64 44.6 58.376 50 32 24.673 5.624 50 0 44.6Z" clip-rule="evenodd"/></svg>
</template>
